// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datasource-modal .modal-body {
  margin-left: 15px;
}

.page-content .query {
  margin-left: 0.5em;
  margin-right: 0.5em;
  height: auto;
}

.query-form {
  width: 100%;
  float: left;
  padding: 2em;
  padding-top: 0px;
  background: #a9c4c4;
  border-radius: 19px;
  color: #275362;
  margin-bottom: 1em;
}

.query-result-div {
  width: 100%;
  float: left;
  margin-bottom: 1em;
}

.query-form label {
  color: #275362;
}

.errorMsg {
  color: #cc0000 !important;
}

.query-form .btn {
  margin-right: 5px;
}

.disabled-btn {
  pointer-events: none;
  opacity: 0.5;
}

.query-result-tab {
  height: 60vh;
  display: table-cell;
  text-align: center;
  width: 100vw;
  padding-right: 0.1em;
  background: rgba(140, 181, 181, 0.2117647059);
}

.query-result-div .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
  outline: 0 !important;
}

.querylist-div {
  background: rgba(140, 181, 181, 0.2117647059);
  padding-bottom: 0;
  padding-top: 2px;
  height: 62vh;
}

.querylist-div .GridCustomStyle {
  height: 58vh !important;
}

.query .btn-primary {
  color: #fff;
  background-color: #265160;
  border-color: #265160;
}

.query .btn-primary:hover {
  background-image: none !important;
  background-color: transparent !important;
}

.query .deactivateDash .react-switch-bg {
  background: rgb(39, 83, 98) !important;
}

.query .react-switch-handle {
  background: #fff !important;
}

.disappear {
  display: none;
}

#add-query-btn {
  margin-left: 1em;
  margin-bottom: 10px;
}

.query .modal-content .btn-primary {
  color: #fff !important;
  background-color: #275362 !important;
  border-color: #275362 !important;
}

.query-form-close-btn {
  float: right;
  position: relative;
  top: 5px;
}

.query-result-div .nav-tabs .nav-link.active {
  background: #265160 !important;
  color: white !important;
}

.query-result-div .nav-tabs .nav-link {
  border: 1px solid #265160 !important;
}

.query-result-div .nav-tabs {
  border-bottom: 1px solid #275362 !important;
}

.query-result-details {
  padding: 0.5em;
  background: #a2b7ca;
  color: black;
  font-weight: bolder;
}

.query-result-details span {
  color: #0c3d52;
}

.query-result-text-tab {
  padding-top: 2em;
}

.query-result-text-tab span {
  float: left;
}`, "",{"version":3,"sources":["webpack://./../gui/src/public/css/query.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,mBAAA;EACA,YAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AACJ;;AACA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;AAEJ;;AAAA;EACA,cAAA;AAGA;;AAAA;EACI,yBAAA;AAGJ;;AADA;EACI,iBAAA;AAIJ;;AADA;EACI,oBAAA;EACA,YAAA;AAIJ;;AADA;EACI,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EAEA,oBAAA;EACA,6CAAA;AAGJ;;AAAA;EACI,qBAAA;AAGJ;;AAAA;EACI,6CAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAGJ;;AADA;EACI,uBAAA;AAIJ;;AAFA;EACI,WAAA;EACA,yBAAA;EACA,qBAAA;AAKJ;;AAFA;EACI,iCAAA;EACA,wCAAA;AAKJ;;AAFA;EACI,sCAAA;AAKJ;;AAHA;EACI,2BAAA;AAMJ;;AAFE;EACI,aAAA;AAKN;;AAFE;EACE,gBAAA;EACA,mBAAA;AAKJ;;AAHE;EACE,sBAAA;EACA,oCAAA;EACA,gCAAA;AAMJ;;AAHE;EACE,YAAA;EACA,kBAAA;EACA,QAAA;AAMJ;;AAFE;EACE,8BAAA;EACA,uBAAA;AAKJ;;AAHE;EACE,oCAAA;AAMJ;;AAHE;EACI,2CAAA;AAMN;;AAHE;EACE,cAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AAMJ;;AAHE;EAEE,cAAA;AAKJ;;AAFE;EACE,gBAAA;AAKJ;;AAFE;EACE,WAAA;AAKJ","sourcesContent":[".datasource-modal .modal-body{\n    margin-left:15px;\n}\n\n.page-content .query{\n    margin-left: 0.5em;\n    margin-right: 0.5em;\n    height: auto;\n}\n\n.query-form{\n    width: 100%;\n    float: left;\n    padding: 2em;\n    padding-top: 0px;\n    background:#a9c4c4;\n    border-radius: 19px;\n    color:#275362;\n    margin-bottom: 1em;\n    }\n.query-result-div{\n    width: 100%;\n    float: left;\n    margin-bottom: 1em;\n}\n.query-form label{\ncolor:#275362;\n    \n}\n.errorMsg {\n    color: #cc0000 !important;\n}\n.query-form .btn{\n    margin-right: 5px;\n}\n\n.disabled-btn{\n    pointer-events: none;\n    opacity: 0.5;\n}\n\n.query-result-tab{\n    height: 60vh;\n    display: table-cell;\n    text-align: center;\n    width: 100vw;\n    // padding-left: 2em;\n    padding-right: 0.1em;\n    background: #8cb5b536;\n}\n\n.query-result-div .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link{\n    outline: 0!important;\n}\n\n.querylist-div{\n    background: #8cb5b536;\n    padding-bottom: 0;\n    padding-top: 2px;\n    height: 62vh;\n}\n.querylist-div .GridCustomStyle{\n    height: 58vh !important;\n}\n.query .btn-primary{\n    color: #fff;\n    background-color: #265160;\n    border-color: #265160;\n  }\n  \n.query .btn-primary:hover{\n    background-image:none !important;\n    background-color:transparent !important;\n  }\n  \n.query .deactivateDash .react-switch-bg{\n    background: rgb(39, 83, 98)  !important;\n  }\n.query .react-switch-handle{\n    background: #fff !important;\n  \n  }\n\n  .disappear{\n      display: none;\n  }\n\n  #add-query-btn{\n    margin-left: 1em;\n    margin-bottom: 10px;\n  }\n  .query .modal-content .btn-primary{\n    color: #fff !important;\n    background-color: #275362 !important;\n    border-color: #275362 !important;\n  }\n\n  .query-form-close-btn{\n    float: right;\n    position: relative;\n    top: 5px;\n  }\n\n  \n  .query-result-div .nav-tabs .nav-link.active{\n    background: #265160 !important;\n    color:white !important;\n  }\n  .query-result-div .nav-tabs .nav-link{\n    border: 1px solid #265160 !important;\n  }\n\n  .query-result-div .nav-tabs{\n      border-bottom: 1px solid #275362 !important;\n  }\n\n  .query-result-details{\n    padding: 0.5em;\n    background:#a2b7ca;\n    color:black;\n    font-weight: bolder;\n  }\n\n  .query-result-details span\n  {\n    color: #0c3d52;\n  }\n\n  .query-result-text-tab{\n    padding-top: 2em;\n  }\n\n  .query-result-text-tab span{\n    float: left;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
